module.exports = __webpack_public_path__ + "static/img/login-bg.0899ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-bg.jpg
// module id = /q00
// module chunks = 1